import { createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-564ebad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, "예약하시려면 로그인이 필요합니다.", -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, "월예약 가능한 날짜가 없습니다.", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, " 월 결제 금액이 일결제 금액보다 높아 일결제로 진행 합니다. ", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, " 만석인 날짜가 있어 월예약이 불가합니다. 일예약으로 진행해주세요. ", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, "이미 예약한 날짜가 있어 월예약이 불가합니다.", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#center" }, [
      ($setup.shouldShowSeatAndPayment)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-backdrop",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.toggleShowSeatAndPayment(false)), ["self"]))
          }, [
            _createVNode(_Transition, {
              appear: "",
              name: "slide-up"
            }, {
              default: _withCtx(() => [
                _createVNode($setup["SeatAndPayment"], {
                  turnId: $props.turnId,
                  getOnBusStopId: $props.getOnBusStopId,
                  getOffBusStopId: $props.getOffBusStopId,
                  bookingDates: $setup.bookingDates,
                  selectedDateInfo: $setup.bookingDates?.[0],
                  oneTimeFare: $props.lineFare?.monthlyFare,
                  totalAmount: $props.lineFare?.monthlyFare,
                  seatsSelectable: $props.seatsSelectable,
                  currentBookInterval: $setup.BookIntervalCode.MONTH,
                  onOnClickSeat: $setup.updateSeatNumbers
                }, null, 8 /* PROPS */, ["turnId", "getOnBusStopId", "getOffBusStopId", "bookingDates", "selectedDateInfo", "oneTimeFare", "totalAmount", "seatsSelectable", "currentBookInterval"])
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true)
    ])),
    ($setup.showLoginRequriedAlertForBook)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          title: "예약하기",
          okButtonTitle: "로그인하기",
          cancelButtonTitle: "취소",
          onOnClickOkButton: $setup.goToLoginPage,
          onOnClickCancelButton: _cache[1] || (_cache[1] = ($event: any) => ($setup.showLoginRequriedAlertForBook = false))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    ($setup.shouldShowEmptyMonthlyBookableDatesModal)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 1,
          title: "월예약 불가",
          okButtonTitle: "확인",
          onOnClickOkButton: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowEmptyMonthlyBookableDatesModal(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    ($setup.shouldShowMonthlyBookExpensiveModal)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 2,
          title: "월예약 불가",
          okButtonTitle: "확인",
          onOnClickOkButton: _cache[3] || (_cache[3] = ($event: any) => (
      [
        $setup.toggleShowMonthlyBookExpensiveModal(false),
        $setup.emitToggleShowBookDetail(true),
      ]
    ))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    ($setup.shouldShowHasFullyBookedDateModal)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 3,
          title: "월예약 불가",
          okButtonTitle: "확인",
          onOnClickOkButton: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleShowHasFullyBookedDateModal(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    ($setup.shouldShowHasBookedDateModal)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 4,
          title: "월예약 불가",
          okButtonTitle: "확인",
          onOnClickOkButton: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleShowHasBookedDateModal(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}